import { Checkbox } from "@/components/ui/checkbox.tsx";
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form.tsx";
import { FunctionComponent, ReactNode } from "react";

export type CheckboxFieldProps = {
	name: string;
	label: ReactNode;
	description?: ReactNode;
};

export const CheckboxField: FunctionComponent<CheckboxFieldProps> = (props) => {
	const { name, label, description } = props;
	return (
		<FormField
			name={name}
			render={({ field }) => (
				<FormItem className={"flex flex-row items-start gap-3 space-y-0"}>
					<FormControl>
						<Checkbox
							checked={field.value === true}
							onCheckedChange={(checked) => field.onChange(checked === true)}
						/>
					</FormControl>
					<div className={"flex flex-col gap-1 leading-none"}>
						<FormLabel>{label}</FormLabel>
						<FormDescription>{description}</FormDescription>
						<FormMessage />
					</div>
				</FormItem>
			)}
		/>
	);
};
